import React from "react";
import SearchForm from "../../components/flights/SearchForm";
import Benefits from "../../components/flights/Benefits";
import PopularDestinations from "../../components/flights/PopularDestinations";
import { addDays } from "date-fns";
import Header from "../../components/flights/Header";
import SearchTabs from "../../components/common/SearchTabs"

function HomePage() {
  // Calculate default dates (7 and 14 days from today)
  const defaultDates = [addDays(new Date(), 7), addDays(new Date(), 14)];

  const handleDestinationSelect = (destination) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <div
        className="min-h-screen bg-cover bg-center relative"
        style={{ backgroundImage: "url('/background2.jpeg')" }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
        <div className="relative">
          <Header isTransparent={true} />
          <div className="pt-12 md:pt-20 px-4">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-2 md:mb-4 text-center text-white">
              Search & Book Flights
            </h1>
            <p className="text-lg md:text-2xl font-bold text-center text-white mb-8">
              Explore the best deals online today
            </p>
          </div>
      <SearchTabs />

          <SearchForm
            initialOrigin="London (LON)"
            initialDateRange={defaultDates}
            selectedDestination=""
            initialPassengers={{
              adults: 1,
              children: 0,
              infants: 0,
              class: "Economy",
            }}
          />
        </div>
      </div>
      <Benefits />
      <PopularDestinations onDestinationSelect={handleDestinationSelect} />
    </div>
  );
}

export default HomePage;
